/**
 * FCM Token Storage Utility
 *
 * Reads FCM token directly from window.fcmToken (injected by app during WebView initialization).
 */

/**
 * Get FCM token from window
 * The token is injected by the app during WebView initialization via JavaScript injection.
 *
 * @returns token string or null if not found
 */
export default function getFCMToken(): string | null {
  try {
    if (typeof window === "undefined") {
      return null;
    }

    const token = window.fcmToken;

    if (token && typeof token === "string" && token.length > 0) {
      return token;
    }

    return null;
  } catch (error) {
    return null;
  }
}

// Named export for backward compatibility
export { getFCMToken };
